import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Submission Records API (school → admin file uploads).
// Files travel as base64 strings inside JSON bodies. The backend enforces
// 10 MB / file and 10 files / submission caps.
export const MAX_FILES_PER_SUBMISSION = 10;
export const MAX_FILE_BYTES = 8 * 1024 * 1024;

// Strip the `data:image/png;base64,` prefix from a DataURL.
const stripDataUrl = (dataUrl) => (dataUrl || "").split(",", 2)[1] || "";

// Read a File object → { name, mime, size, dataB64 }
export const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve({
        name: file.name,
        mime: file.type || "application/octet-stream",
        size: file.size,
        dataB64: stripDataUrl(reader.result),
      });
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const submissionApi = {
  list: () => axios.get(`${API}/submissions`).then((r) => r.data),
  create: ({ year, month, note, files }) =>
    axios.post(`${API}/submissions`, { year, month, note, files }).then((r) => r.data),
  appendFiles: (submissionId, files) =>
    axios.post(`${API}/submissions/${submissionId}/files`, { files }).then((r) => r.data),
  downloadFile: (submissionId, fileId) =>
    axios.get(`${API}/submissions/${submissionId}/files/${fileId}`).then((r) => r.data),
  remove: (submissionId) =>
    axios.delete(`${API}/submissions/${submissionId}`).then((r) => r.data),
  reply: (submissionId, reply) =>
    axios.post(`${API}/submissions/${submissionId}/reply`, { reply }).then((r) => r.data),
};

// Trigger a browser download from a {name, mime, dataB64} blob.
export function triggerDownload({ name, mime, dataB64 }) {
  const byteChars = atob(dataB64);
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
  const blob = new Blob([bytes], { type: mime || "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name || "file";
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
